import form from './form';
import login from './login';

const en = {
  form: form,
  login: login,
};

export default en;
